import React, { Component } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import MainMenu from "../components/mainMenu";
import SubNavigation from "../components/subNavigation";
import TopBanner from "../components/topBanner";
import ImageCarousel from "../components/imageCarousel";
import AnimatedBackground from "../components/animatedBackground";
import InstagramFeed from "../components/instagramFeed";
import Footer from "../components/footer";

export default class SuitAlpine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDropdown: false,
    };
  }

  componentDidMount() {
    document.title = "QwixSkinz || Alpine Skiing Race Suits";
  }

  componentWillUnmount() {}

  render() {
    return (
      <React.Fragment>
        <MainMenu />
        <TopBanner
          bannerHeight="full"
          title="Alpine Suit"
          images={[
            "alpine/val-d-isere-alpine-training.jpg",
            "alpine/erik-guay-professional-alpine-skier.jpg",
            "alpine/wind-tunnel-alpine-race-suit.jpg",
          ]}
        />
        <SubNavigation
          location={this.props.location}
          refs={this.refs}
          navItems={[
            {
              title: "Suit Overview",
              id: "overview",
            },
          ]}
        />{" "}
        {/* Alpine Suit Overview */}
        <div className="qs-b" ref="overview">
          <div className="container block-wrap behind-trees">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Alpine Ski Race Suits</h1>
                </div>
              </div>
              <div className="col-12 col-md-4 content dark pt-0">
                <p className="lead">
                  Qwixskinz has designed, researched, wind tunnel tested &amp;
                  developed World Cup &amp; national alpine ski team race suits
                  for various nations under the team’s clothing sponsor labels
                  resulting in performances that have reached the top of the
                  podium.
                </p>
                <p>
                  If your team wants the Qwixskinz advantage we have given other
                  nations, whether you are the sport’s governing body or the
                  title sponsor, contact us. We want to work with you to make
                  you faster...
                </p>
              </div>
              <div className="col-12 col-md-8">
                <div className="">
                  <ImageCarousel
                    className="large-media"
                    images={[
                      "/images/suits/alpine/audi-alpine-ski-race-podium-poster.jpg",
                      "/images/suits/alpine/broderick-thompson-alpine-race-suit.jpg",
                      "/images/suits/alpine/d-cook-super-g-alpine-race-suit.jpg",
                      "/images/suits/alpine/alpine-ski-speed-suit.jpg",
                      "/images/suits/alpine/alpine-ski-speed-suit-2.jpg",
                      "/images/suits/alpine/Erik-Guay-Val-D-Isere.jpg",
                      "/images/suits/alpine/Erik-Guay-World-cup-alpine-skiing .jpg",
                      "/images/suits/alpine/Manny-WM.jpg",
                      "/images/suits/alpine/Erik-Guay-WM2.jpg",
                      "/images/suits/alpine/Manuel-Osborne-Paradis.jpg",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <InstagramFeed />
        <Footer />
        <AnimatedBackground />
      </React.Fragment>
    );
  }
}
